/** @file Provides the logistics admin consumer list with saved data-view filtering. */
import Page from "../../../layout/Page";
import PageContent from "../../../layout/PageContent";
import PageHeader from "../../../layout/PageHeader";
import {ViewFilter} from "../../../components/ViewFilter";
import {ConsumerList} from "../../brand/consumers/BrandConsumersPage";

/** Renders the read-only consumer list with the shared view banner and clear action. */
export const LogisticsConsumersListPage = () => {
   return <Page>
      <PageHeader title="Consumers"/>
      <PageContent fullHeight>
         <ViewFilter dataType="consumers">
            {(viewId) => <ConsumerList key={viewId || ''} viewId={viewId} readOnly/>}
         </ViewFilter>
      </PageContent>
   </Page>;
};
